<script setup lang="ts">
import type { AppointmentTableRow } from './types'

const props = defineProps<{
  rowData: AppointmentTableRow
  isSelected: boolean
}>()

const emit = defineEmits<{
  toggle: [rowKey: string]
}>()

function onToggle() {
  emit('toggle', props.rowData.transaction.stable_transaction_key)
}
</script>

<template>
  <div class="flex items-center justify-center">
    <el-checkbox :model-value="isSelected" @change="onToggle" />
  </div>
</template>
